export default __webpack_public_path__ + "static/media/team-marlon.e6db1cd9.jpg";